(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/pickers/pix-mode-picker.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/pickers/pix-mode-picker.js');

'use strict';

const RadioGroup = svs.ui.form.RadioGroup;
const RadioButton = svs.ui.form.RadioButton;
const {
  pixModes
} = svs.racing.common.constants;
const PixModePicker = _ref => {
  let {
    selectedPixMode,
    setPixMode
  } = _ref;
  return React.createElement("div", {
    className: "bet-mode-picker-holder"
  }, React.createElement("div", {
    className: "picker-header"
  }, React.createElement("span", null, "Hur vill du starta?")), React.createElement("div", {
    className: "bet-mode-picker form-toggle-racing"
  }, React.createElement(RadioGroup, {
    multipleLines: true,
    size: "200",
    thin: true
  }, React.createElement(RadioButton, {
    branding: "racing",
    checked: selectedPixMode === pixModes.FROM_SCRATCH,
    name: "toggle-radio-group-pix-mode-picker",
    onChange: () => setPixMode(pixModes.FROM_SCRATCH),
    value: "1"
  }, "Fr\xE5n grunden"), React.createElement(RadioButton, {
    branding: "racing",
    checked: selectedPixMode === pixModes.CUSTOM,
    name: "toggle-radio-group-pix-mode-picker",
    onChange: () => setPixMode(pixModes.CUSTOM),
    value: "0"
  }, "Egna val"))));
};
svs.racing_game.components.play.PixModePicker = PixModePicker;

 })(window);